import { InfoOutlined, KeyboardArrowDown } from "@mui/icons-material";
import { MenuItem, Stack, styled, Tooltip, Typography } from "@mui/material";
import Select, { type SelectChangeEvent } from "@mui/material/Select";

const StyledInfoIcon = styled(InfoOutlined)(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.text.secondary,
}));

/** @deprecated Import from `@monthly/ui` instead
 * @example
 * import { DropdownProps } from '@monthly/ui' */
export interface DropdownProps {
  label: string;
  value: string;
  disabled?: boolean;
  options: string[];
  disabledOptions?: string[];
  onChange: (value: string) => void;
  placeholder?: string;
  tooltip?: string;
  minWidth?: number;
}

/** @deprecated Import from `@monthly/ui` instead
 * @example
 * import { Dropdown } from '@monthly/ui' */
export function Dropdown({
  label,
  value,
  disabled = false,
  options,
  disabledOptions,
  onChange,
  placeholder = "Selecciona",
  tooltip,
  minWidth = 160,
}: DropdownProps) {
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    onChange(event.target.value as string);
  };

  return (
    <Stack gap={1.5}>
      <Stack flexDirection="row" alignItems="center" gap={0.75}>
        <Typography
          variant="caption"
          sx={(theme) => ({
            color: theme.palette.secondary.dark,
          })}
        >
          {label}
        </Typography>
        {tooltip && (
          <Tooltip title={tooltip} placement="right">
            <StyledInfoIcon />
          </Tooltip>
        )}
      </Stack>
      <Select
        disabled={disabled}
        sx={{ minWidth, maxHeight: 40 }}
        value={value}
        onChange={handleChange}
        displayEmpty
        IconComponent={KeyboardArrowDown}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
            },
          },
        }}
        renderValue={(selected) => {
          return selected ? (
            <Typography variant="body2" component="span">
              {selected}
            </Typography>
          ) : (
            <Typography variant="body2" component="span" color="text.secondary">
              {placeholder}
            </Typography>
          );
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            disabled={disabledOptions?.includes(option)}
          >
            <Typography variant="body2" component="span">
              {option}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
}
